export const AMOK_PASTE = {
  handle: "angkor-amok-curry-paste-280g",
  shopPath: "/products",
  productPath: "/products/angkor-amok-curry-paste-280g",
  title: "ANGKOR Amok Curry Paste",
  jarSize: "280 g",
  price: 15,
  priceDisplay: "$15.00",
  ingredients:
    "Galangal, shallots, garlic, turmeric, lemongrass, shrimp (crustacean), kaffir lime, fish sauce (fish), vegetable oil and long red chilli.",
  allergens: "Contains crustacean and fish.",
  crossContact:
    "Our kitchen also handles peanuts, tree nuts, gluten, soy, sesame, egg, milk, crustaceans and fish.",
  shippingLabel: "Australia-wide Parcel Post",
  shippingPrice: 22.75,
  shippingPriceDisplay: "$22.75",
  maximumQuantity: 50,
} as const;
